<template>
  <div class="card">
      <div class="card-header bg-transparent text-left">
        <div class="row">
            <div class="col-10 text-md-left text-center">
                <strong>{{periodText}}</strong>
            </div>
            <div class="col-2 text-md-right text-center">
              <font-awesome-icon icon="sync" @click="updateData()" rel="tooltip" title="Atualizar dados do gráfico" role="button" />
            </div>
        </div>
      </div>

      <div class="card-body">
          <sales 
            v-if="isLoading"
            :options="options"
            :chart-data="chartdata"
          />
          <font-awesome-icon v-else icon="spinner" size="2x" spin  />
      </div>

      <div class="card-footer bg-transparent text-left">
          <div class="row" >
              <div class="col-md-6 col-12 text-md-right text-center">
                  <strong>Valor total:</strong> {{total}}
              </div>
              <div class="col-md-6 col-12 text-md-right text-center" >
                <div class="btn-group" role="group" aria-label="Basic example">
                  <button type="button" v-bind:class="[active == 0 ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="[period = 1, active = 0]"  class="btn btn-sm">Hoje</button>
                  <button type="button" v-bind:class="[active == 1 ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="[period = 7, active = 1]" class="btn btn-sm">7 Dias</button>
                  <button type="button" v-bind:class="[active == 2 ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="[period = 15, active = 2]" class="btn btn-sm">15 Dias</button>
                </div>
              </div>
          </div>
      </div>
  </div> 
</template>
<script>
    import sales from '@/components/graphs/salesPayment.vue'
    export default {
        name: 'homeSalesPayment',
        components:{
          sales
        },
        computed: {
            getToken: function(){
                return this.$store.getters.getToken
            }
        },
        data(){
          return {
            active: 1,
            period: 7,
            periodText: 'Formas de pagamento nos ultimos 7 Dias',
            total: 0,
            isLoading: false,
            chartdata: {
                labels  : [],
                datasets: []
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                  display: true,
                  labels: {
                    // padding: 50
                  }
                },
                tooltips: {
                  enabled: true,
                  mode: 'single',
                  callbacks: {

                  }
                }
            }
          }
        },
        methods: {
            updateData: function(){
                let url = server + 'graficos/formaspagamento/' + this.period
                this.isLoading = false
                fetch(url, {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    })
                })
                    .then(response => (response.json()))
                    .then(responseJSON => {
                      let data = responseJSON.response
                      let labels = []
                      let values = []
                      let colors = []

                      this.chartdata.labels = []
                      this.chartdata.datasets = []

                      this.total = 0

                      const formatter = new Intl.NumberFormat('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        minimumFractionDigits: 2
                      })

                      for (let index = 0; index < data.length; index++) {
                          const element = data[index]
                          let str = element.TOTAL_FORMA

                          this.total = parseFloat(this.total) + parseFloat(str)

                          labels.push(element.DESCRICAO + ' - ' + formatter.format(str) )
                          values.push(str)
                          colors.push(this.getRandomColor())
                      }

                      this.total = formatter.format(this.total)

                      this.chartdata.labels = labels
                      this.chartdata.datasets.push({
                          label: 'Valor',
                          backgroundColor: colors,
                          data: values
                      })

                      console.log('Chart data set', '=>', this.chartdata)
                      this.options.tooltips.callbacks.label = function(tooltipItem, data){
                          return  data.labels[tooltipItem.index]
                      }
                      this.isLoading = true
                    })
                    .catch(error => {
                      console.log('Error exception', '=>', error)
                    });
            },
            getRandomColor: function(){
                let letters = '0123456789ABCDEF'
                let color = '#'

                for (var i = 0; i < 6; i++) {
                    color += letters[Math.floor(Math.random() * 16)]
                }

                return color
            }
        },
        mounted () {
            this.updateData()
        },
        watch: {
          period: function(newVal, oldVal){
            if(newVal == 7){
              this.periodText = ' Formas de pagamento nos ultimos 7 Dias'
            }else if(newVal == 15){
              this.periodText = ' Formas de pagamento nos ultimos 15 Dias'
            }else{
              this.periodText = ' Formas de pagamento Hoje'
            }

            this.updateData()
          }
        }      
    }
</script>